// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ValidationVocabularyMetaSchemaType
 */
export interface ValidationVocabularyMetaSchemaType {}

/**
 * Check if a given object implements the ValidationVocabularyMetaSchemaType interface.
 */
export function instanceOfValidationVocabularyMetaSchemaType(
  value: object
): value is ValidationVocabularyMetaSchemaType {
  return true;
}

export function ValidationVocabularyMetaSchemaTypeFromJSON(
  json: any
): ValidationVocabularyMetaSchemaType {
  return ValidationVocabularyMetaSchemaTypeFromJSONTyped(json, false);
}

export function ValidationVocabularyMetaSchemaTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ValidationVocabularyMetaSchemaType {
  return json;
}

export function ValidationVocabularyMetaSchemaTypeToJSON(
  json: any
): ValidationVocabularyMetaSchemaType {
  return ValidationVocabularyMetaSchemaTypeToJSONTyped(json, false);
}

export function ValidationVocabularyMetaSchemaTypeToJSONTyped(
  value?: ValidationVocabularyMetaSchemaType | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
